module.exports = __webpack_public_path__ + "static/media/booked_pass.c7b1a266.svg";